import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import EventFinished from "src/components/EventFinished";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import TitleSection from "src/components/TitleSection/TitleSection";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import DynamicGoogleFormSubmitter from "src/components/Form/DynamicGoogleFormSubmitter";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";

const IMAGE_BASE = "promotions/gaming-machines/rcg-cruise-november-2026";

const RcgCruiseNovember2026Rsvp = () => {
  const { t, i18n } = useTranslation();
  const parallaxImage = useResponsiveImageUrl(`${IMAGE_BASE}/rc-cruise-parallax.jpg`);

  return (
    <Div>
      <Hero
        bgImage="promotions/gaming-machines/rcg-cruise-november-2026/rc-hero-image-2400x1150px.jpg"
        image={`promotions/gaming-machines/rcg-cruise-november-2026/rc-logo-2400x900px-${i18n.language}.png`}
        imageAlt={t("rcgCruiseNovember2026Rsvp.hero.logoAlt")}
        title={t("rcgCruiseNovember2026Rsvp.hero.title")}
        description={t("rcgCruiseNovember2026Rsvp.hero.subtitle")}
        descriptionBgColor="#b8a47d"
        className="rcg-hero"
        fluidImage
      />
      <EventFinished
        scheduleKeyName="rcgCruiseNovember2026Rsvp"
        eventType="promotion"
      />
      <MainContentDiv>
        <IntroSection>
          <container-div>
            <TitleSection
              title="rcgCruiseNovember2026Rsvp.content.title"
              text={t("rcgCruiseNovember2026Rsvp.content.text")}
              borderColor="#c5b48a"
              dark={false}
              as="h2"
              className="intro-title"
            />
          </container-div>
        </IntroSection>
        <ContentBand>
        <FormSection $bgImage={parallaxImage}>
          <div className="band-inner">
            <div className="form-column">
          <TitleSection
            title="rcgCruiseNovember2026Rsvp.form.heading"
            borderColor="#c5b48a"
            dark={true}
            as="h2"
            className="form-title"
          />
          <DynamicGoogleFormSubmitter
            formId="AKfycbxjL7DGt5tbZwf2J-RLDe5aPWxWsWnc7_mGicenA3B5YaM0gvZPf8F_NH2FchB-w_fY"
            sheetName="RSVP"
            formTextKey="rcgCruiseNovember2026Rsvp"
            titles={false}
            formFields={[
              {
                id: "FirstName",
                label: "firstName",
                type: "text",
                required: true
              },
              {
                id: "LastName",
                label: "lastName",
                type: "text",
                required: true
              },
              {
                id: "PlayerID",
                label: "pgPlayerId",
                type: "text",
                required: true,
                placeholder: "pgPlayerIdPlaceholder"
              },
              {
                id: "Dates",
                label: "date",
                type: "select",
                required: true,
                options: t("rcgCruiseNovember2026Rsvp.form.dateOptions", { returnObjects: true })
              }
            ]}
          />
            </div>
          </div>
        </FormSection>
        <DetailsSection>
          <div className="band-inner">
            <div className="details-card">
              <SubTitleSection
                subTitle={t("rcgCruiseNovember2026Rsvp.eventDetails.title")}
                borderColor="#c5b48a"
                dark={true}
                as="h2"
                subtitleColor="#fff"
                className="details-title"
              />
              <div className="details-grid">
                <div>
                  <span className="label">
                    {t("rcgCruiseNovember2026Rsvp.eventDetails.whereLabel")}
                  </span>
                  <p>{t("rcgCruiseNovember2026Rsvp.eventDetails.whereText")}</p>
                </div>
                <div>
                  <span className="label">
                    {t("rcgCruiseNovember2026Rsvp.eventDetails.whenLabel")}
                  </span>
                  <p>{t("rcgCruiseNovember2026Rsvp.eventDetails.whenText")}</p>
                </div>
                <div>
                  <span className="label">
                    {t("rcgCruiseNovember2026Rsvp.eventDetails.timeLabel")}
                  </span>
                  <p>{t("rcgCruiseNovember2026Rsvp.eventDetails.timeText")}</p>
                </div>
              </div>
            </div>
          </div>
        </DetailsSection>
        <ImageWrapper>
          <ResponsiveImage
            src="promotions/gaming-machines/rcg-cruise-november-2026/rc-cruise-photos-november.png"
            alt={t("rcgCruiseNovember2026Rsvp.eventDetails.title")}
          />
        </ImageWrapper>
        </ContentBand>
        <NoteSection>
          <container-div>
            <ReactMarkdown className="rsvp-note">
              {t("rcgCruiseNovember2026Rsvp.content.alternateRsvp")}
            </ReactMarkdown>
          </container-div>
        </NoteSection>
      </MainContentDiv>
    </Div>
  );
};

const Div = styled.div`
  width: 100%;
  height: auto;

  .hero_container {
    margin-bottom: 120px;
    background-position: bottom;
    overflow: visible;
  }

  .rcg-hero {
    .hero_image_container {
      padding: 20px 20px 40px;
      min-height: 900px;
      justify-content: flex-start;
    }

    .hero_image {
      max-width: 820px;
      margin-top: 140px;
      width: 100%;
    }

    .hero_text_container {
      position: relative;
      bottom: -120px;
      background-color: #b8a47d;
      backdrop-filter: none;
      padding: 40px 20px;
      z-index: 1;
    }

    .hero_text_container h1 {
      margin-bottom: 20px;
      color: #fff;
    }

    .hero_text_container p {
      margin: 0;
      color: #fff;
    }
  }

  @media (max-width: 991px) {
    .hero_container {
      margin-bottom: 180px;
    }

    .rcg-hero {
      .hero_image_container {
        min-height: 400px;
        padding: 20px;
      }

      .hero_text_container {
        bottom: -180px;
      }
    }
  }
`;

const MainContentDiv = styled.div`
  background-color: #000000;
  width: 100%;
`;

const NoteSection = styled.div`
  background-color: #000000;
  width: 100%;

  .rsvp-note {
    margin: 40px auto;
    padding: 0;
    text-align: center;
    font-size: 1.05rem;
    font-style: italic;
    color: rgba(255, 255, 255, 0.88);
  }

  .rsvp-note a,
  .rsvp-note strong {
    color: #fff;
    font-style: italic;
    text-decoration: none;
  }

  .rsvp-note a:hover,
  .rsvp-note a:focus {
    text-decoration: underline;
  }
`;

const IntroSection = styled.section`
  background-color: #000000;
  width: 100%;
  padding: 40px 1.5rem;

  .intro-title {
    max-width: 880px;
    margin: 0 auto;
    padding: 0;

    h2 {
      white-space: pre-line;
    }

    strong {
      color: #baa47d;
    }
  }

  @media (max-width: 992px) {
    padding: 40px 0;

    .intro-title h2,
    .intro-title p {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

const ContentBand = styled.div`
  position: relative;

  .band-inner {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  @media (max-width: 992px) {
    .band-inner {
      padding: 0 20px;
    }
  }
`;

const DetailsSection = styled.section`
  background-color: #000000;
  width: 100%;

  .details-card {
    color: var(--white);
    max-width: 520px;
    padding: 40px 0;
  }

  .details-title {
    padding: 0 0 20px;
  }

  .details-grid {
    display: grid;
    gap: 1.5rem;
    grid-template-columns: 1fr;
  }

  .details-grid p {
    margin: 0.4rem 0 0;
    white-space: pre-line;
    color: var(--white);
  }

  .label {
    font-weight: 700;
    color: #baa47d;
    display: block;
  }

  @media (max-width: 992px) {
    .details-card {
      max-width: 100%;
      padding: 40px 0;
    }
  }
`;

const ImageWrapper = styled.div`
  --text-end: calc(
    (100vw - min(100vw, 1400px)) / 2 + 2rem + 520px + 1.25rem
  );
  --img-width: min(
    560px,
    calc(100vw - var(--text-end) - 1.2rem),
    calc(420px + max(0px, 100vw - 1000px) * 0.22)
  );
  position: absolute;
  top: 50%;
  right: max(1.2rem, calc(100vw - var(--text-end) - var(--img-width)));
  transform: translateY(-50%);
  width: var(--img-width);
  max-height: 88%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  pointer-events: none;

  img {
    width: 100%;
    max-height: 100%;
    height: auto;
    object-fit: contain;
  }

  @media (min-width: 1800px) {
    right: max(1.2rem, calc((100vw - 1400px) / 2 + 5rem));
  }

  @media (max-width: 992px) {
    position: static;
    transform: none;
    width: 100%;
    max-width: none;
    max-height: none;
    margin: 0;
    padding: 0;
    pointer-events: auto;

    img {
      width: 100%;
      max-width: none;
      max-height: none;
      margin: 0;
      display: block;
    }
  }
`;

const FormSection = styled.section`
  position: relative;
  background-color: #000000;
  width: 100%;
  padding: 40px 0;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: #061525;
    background-image: url(${(props) => props.$bgImage});
    background-repeat: no-repeat;
    background-position: right center;
    background-size: cover;
    z-index: 0;
  }

  .band-inner {
    position: relative;
    z-index: 1;
  }

  .form-column {
    max-width: 520px;
  }

  .form-title {
    align-items: flex-start;
    text-align: left;
    padding: 0;

    h2 {
      text-align: left;
      color: #fff;
    }
  }

  .form-container {
    background-color: #0c1d2f;
    border: none;
    margin: 0;

    button {
      background: #baa47d;

      &:hover {
        background: var(--white);
      }
    }

    .form-link {
      color: #baa47d;
    }
  }

  @media (max-width: 992px) {
    padding: 40px 0;

    &::before {
      display: none;
    }

    .form-title h2 {
      padding-left: 0;
      padding-right: 0;
    }

    .form-column {
      max-width: 520px;
      margin: 0 auto;
    }

    .form-title {
      align-items: center;
      text-align: center;

      h2 {
        text-align: center;
        color: #fff;
      }
    }

    .form-container {
      margin: 0 auto;
    }
  }
`;

export default RcgCruiseNovember2026Rsvp;
